import { Box, CssBaseline, Drawer, IconButton, Toolbar } from "@mui/material";
import { useState } from "react"
import AdminSidebar from "./sidebar";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const AdminNavigation = () => {
  const [open, setOpen] = useState(false);
  const drawerWidth = 300;

  return (
    <Box sx={{position: "sticky", top: "0", background: "#F8FBFB", zIndex: "10" }}>
      <CssBaseline />

      <Toolbar sx={{ height: "64px" }}>
        <IconButton onClick={() => setOpen(!open)}>
          <MenuIcon />
        </IconButton>
      </Toolbar>
      <Box
        component="nav"
      >
        <Drawer
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: "black",
              color: "white",
            },
          }}
          open={open}
          onClose={() => setOpen(false)}
        >
          <AdminSidebar 
            closeButton={
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon sx={{ color: "white" }} />
              </IconButton>
            } 
          />
        </Drawer>
      </Box>
    </Box>
  )
}

export default AdminNavigation